import { render, staticRenderFns } from "./FilterBanner.vue?vue&type=template&id=627135d5&scoped=true"
import script from "./FilterBanner.vue?vue&type=script&lang=ts"
export * from "./FilterBanner.vue?vue&type=script&lang=ts"
import style0 from "./FilterBanner.vue?vue&type=style&index=0&id=627135d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627135d5",
  null
  
)

export default component.exports